const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class LoyaltyRewardsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els.rule) {
      this.els.rule.elements.forEach((el) => {
        this.listeners.add(el, 'click', this.onRuleClick.bind(this))
      })
    }

    if (window.BAO.MediaBreakpoints.isSm) {
      this.externalEls.trigger.elements.forEach((triggerEl) => {
        this.listeners.add(
          triggerEl,
          'click',
          this.handleTierChange.bind(this),
        )
      })
    }
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden='true'])`,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 1,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.7,
              spacing: 1,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.3,
              spacing: 1,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }

  onRuleClick (event) {
    const rule = event.currentTarget
    const id = rule.dataset.ruleId

    const button = document.querySelector(
      `.lion-rule-item[data-rule-id="${id}"] button`,
    )
    if (button) {
      button.click()
    }
  }

  handleTierChange (event) {
    const currentTier = event.target.closest(this.externalEls.trigger.selector)

    this.els.slide.elements.forEach((rewardEl) => {
      if (rewardEl.dataset.tier === currentTier.dataset.tier) {
        rewardEl.setAttribute('aria-hidden', 'false')
      } else {
        rewardEl.setAttribute('aria-hidden', 'true')
      }
    })

    this.setupCarousel()
  }
}

if (!customElements.get('loyalty-rewards-carousel')) {
  customElements.define('loyalty-rewards-carousel', LoyaltyRewardsCarousel)
}
